common.View.create('website_forms::admin.CreateEdit', {

    onDOMLoad() {
        this.initDataset();
        this.reInitDataset();
    },

    initDataset() {
        this.element

            // Listen for type change.
            .find('select[name*="[type]"]')
            .change(this.manageType)

            // Trigger change to update all fields when dataset gets loaded
            .change()
            .end();
    },

    reInitDataset() {
        this.element.find('.crud\\:\\:form-Index button[name="add"]')
            .on('click', this.initDataset.bind(this));
    },

    manageType(event) {
        let el = $(event.currentTarget);
        let valueField = el.closest('.dataset-content').find('input[name*="[value]"]');
        let placeholder = '';

        switch (el.val()) {
            case 'select':
            case 'radio':
            case 'checkbox':
                placeholder = 'Vul hier de dropdown waardes in';
                break;
            case 'email':
                placeholder = 'Vul iets in om mails te versturen naar dit email';
                break;
            case 'submit':
                placeholder = 'Tekst in de knop';
                break;
        }

        valueField.attr('placeholder', placeholder);
        valueField.prop('disabled', el.val() === 'file');
        valueField.prop('required', el.val() === 'hidden');

        if (el.val() === 'file') valueField.val('');
    }
});
